<template>
	<dialog-form :visible.sync="visible" :title="status==0?'新增':'编辑'" :submitFun="submit" :cancelFun="cancle" width="500px"
		:show-close='false' @close="onClose">
		<el-form :model="formData" ref="formRef" label-width="80px">
			<el-form-item label="名字" prop="name">
				<el-input v-model="formData.name" size='medium' placeholder="请输入标签名" />
			</el-form-item>
			<el-form-item label="上级标签" prop="parentId">
				<record-tag-cascader v-if="visible" size='medium' v-model="formData.parentId" :disableIds="[formData.id]"
					:config="{ multiple: false, disabled: false, checkStrictly: true,emitPath:false }"
					style='width:100%' filterable clearable ref="recordTagSelectRef" />
			</el-form-item>
			<el-form-item label="使用年级">
				<select-grade v-model="formData.level" :hasfullGrade="true" style="width:100%" />
			</el-form-item>
			<el-form-item label="标签描述" prop="description">
				<el-input type='textarea' :rows="2" v-model="formData.description" placeholder="请输入描述" />
			</el-form-item>
		</el-form>
	</dialog-form>
</template>

<script>
	import DialogForm from '@/components/dialog-form.vue'
	import RecordTagCascader from '@/views/record/record-tag-cascader.vue'
	import { recordTagApi } from '@/boot-api/record'
	import SelectGrade from '@/components/select-grade.vue'
	export default {
		components: { DialogForm, RecordTagCascader, SelectGrade },
		data() {
			return {
				status: 0,
				visible: false,
				formData: {
					name: null,
					description: null,
					parentId: null,
					level:0,
					id: null
				}
			}
		},

		methods: {
			edit(tag) {
				this.status = 1
				this.visible = true
				Object.assign(this.formData, tag)
			},
			add(parentId,level=0) {
				console.log('parentId=',parentId,level)
				this.formData.parentId = parentId
				this.formData.level=level
				this.status = 0
				this.visible = true
			},
			cancle() {
				this.$refs.formRef.resetFields()
				this.visible = false
			},
			async submit() {
				await recordTagApi.save(this.formData).then(res => {
					this.visible = false
					this.$store.dispatch('record/getTagNodeList')
					this.$refs.recordTagSelectRef.getTagList()
					this.$message.success('添加成功')
				})
			},
			onClose() {
				this.visible = false
				Object.assign(this.$data, this.$options.data())
			}

		}

	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/record/set/record-tag-form.vue